import { Dialog, DialogPanel } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import type { Dispatch, SetStateAction } from 'react';

import { Brand } from './Brand';
import { BasicElements } from './mobile-items/BasicElements';
import { BasicGroupElement } from './mobile-items/BasicGroupElement';
import type { NavbarItems } from './types';

interface MobileNavbarProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: Dispatch<SetStateAction<boolean>>;
  items: NavbarItems;
}

export function MobileNavbar(props: MobileNavbarProps) {
  const { mobileMenuOpen, setMobileMenuOpen, items } = props;

  const groupElements = items
    .filter((item) => 'group' in item)
    .flatMap((item) => item.group);

  return (
    <Dialog
      open={mobileMenuOpen}
      onClose={setMobileMenuOpen}
      className="lg:hidden"
    >
      <div className="fixed inset-0 z-10" />
      <DialogPanel className="fixed inset-y-0 right-0 z-10 flex w-full flex-col justify-between overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-neutral-900/10">
        <div className="p-6">
          <div className="flex items-center justify-between">
            <Link href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">NMRium</span>
              <Brand className="h-8 w-auto" />
            </Link>
            <CloseButton setMobileMenuOpen={setMobileMenuOpen} />
          </div>
          <div className="mt-10 flow-root">
            <div className="-my-6 divide-y divide-neutral-500/10">
              <div className="space-y-2 py-6">
                <BasicElements
                  items={items}
                  setMobileMenuOpen={setMobileMenuOpen}
                />
              </div>
              <div className="space-y-2 py-6">
                {groupElements.map((item) => (
                  <BasicGroupElement
                    key={item.name}
                    item={item}
                    setMobileMenuOpen={setMobileMenuOpen}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  );
}

interface CloseButtonProps {
  setMobileMenuOpen: Dispatch<SetStateAction<boolean>>;
}

function CloseButton(props: CloseButtonProps) {
  const { setMobileMenuOpen } = props;

  return (
    <button
      type="button"
      onClick={() => setMobileMenuOpen(false)}
      className="-m-2.5 rounded-md p-2.5 text-neutral-700"
    >
      <span className="sr-only">Close menu</span>
      <XMarkIcon aria-hidden="true" className="size-6" />
    </button>
  );
}
